import ActivityNotificationsListing from './ActivityNotificationsListing';

export default ActivityNotificationsListing;
